/** @format */

import React from 'react';
import { Grid } from '@mui/material';
import { SelectV, InputV, BusinessAccounts, InputCurrency } from 'components';
import { useFormContext } from 'react-hook-form';

const CalculationMethod = (props) => {
  const { selectChange } = props;
  const methods = useFormContext();
  const { scPriceCalculationType } = methods.watch();

  return (
    <Grid container direction="row" alignItems="center" spacing={4}>
      <Grid item xs={6}>
        <BusinessAccounts errors={methods.formState.errors} control={methods.control} name="scGuildCode" />
      </Grid>
      <Grid item xs={6}>
        <SelectV
          name="scPriceCalculationType"
          options={[
            { value: 'FIXED', label: 'قیمت ثابت' },
            { value: 'ONRESPONSE', label: 'قیمت در هر فراخوانی' },
          ]}
          control={methods.control}
          rules={['required']}
          errors={methods.formState.errors}
          fullWidth
          onChangeFunc={selectChange}
        />
      </Grid>

      {scPriceCalculationType === 'FIXED' && (
        <Grid item xs={6}>
          <InputCurrency
            fullWidth
            errors={methods.formState.errors}
            name="price"
            register={methods.register}
            rules={['required']}
            control={methods.control}
           
          />
        </Grid>
      )}

      {scPriceCalculationType === 'ONRESPONSE' && (
        <>
          <Grid item xs={3}>
            <InputCurrency
              fullWidth
              errors={methods.formState.errors}
              label="حداقل موجودی مصرف کننده"
              name="price"
              register={methods.register}
              rules={['required']}
              control={methods.control}
             
            />
          </Grid>

          <Grid item xs={3}>
            <InputV
              fullWidth
              errors={methods.formState.errors}
              name="scPriceHeader"
              register={methods.register}
              rules={['required']}
              control={methods.control}
            />
          </Grid>

          <Grid item xs={6}>
            <InputV
              fullWidth
              errors={methods.formState.errors}
              name="scPriceInquiryUrl"
              register={methods.register}
              rules={['required']}
              control={methods.control}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default CalculationMethod;
